// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("./image.res.js");

function AlertComponent(props) {
  var handleClose = props.handleClose;
  var alertType = props.alertType;
  var closeIcon;
  closeIcon = alertType.TAG === "Notice" ? Image$ReactHooksTemplate.closeIconWhite : Image$ReactHooksTemplate.closeIcon;
  var backgroundColorCSS;
  switch (alertType.TAG) {
    case "Notice" :
        backgroundColorCSS = "bg-notice";
        break;
    case "Success" :
        backgroundColorCSS = "bg-success";
        break;
    case "Failure" :
        backgroundColorCSS = "bg-failure";
        break;
    case "Warning" :
        backgroundColorCSS = "bg-warning";
        break;
    
  }
  var textColorCSS;
  switch (alertType.TAG) {
    case "Notice" :
        textColorCSS = "text-notice";
        break;
    case "Success" :
        textColorCSS = "text-success";
        break;
    case "Failure" :
        textColorCSS = "text-failure";
        break;
    case "Warning" :
        textColorCSS = "text-warning";
        break;
    
  }
  setTimeout((function (param) {
          Curry._1(handleClose, undefined);
        }), 3000);
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("p", {
                            children: alertType._0,
                            className: textColorCSS + " font-normal text-14-px leading-16-px"
                          }),
                      JsxRuntime.jsx("a", {
                            children: JsxRuntime.jsx("img", {
                                  src: closeIcon
                                }),
                            className: "w-10-px h-10-px flex-grow-0 flex-shrink-0",
                            href: "#",
                            onClick: (function ($$event) {
                                $$event.preventDefault();
                                Curry._1(handleClose, undefined);
                              })
                          })
                    ],
                    className: backgroundColorCSS + " flex justify-between items-center w-350-px min-h-38-px\n    px-12-px py-10-px mx-auto shadow-sm rounded-4px"
                  }),
              className: "absolute right-0 mr-4"
            });
}

var make = AlertComponent;

exports.make = make;
/* react/jsx-runtime Not a pure module */
